import React, { useState } from 'react';

/* Common */
import { Icon, Image, Modal } from '~/components/common';

/* Icons */
import LabelIcon from '~/../symbols/label.svg';
import StarIcon from '~/../symbols/star.svg';
import ElectricIcon from '~/../symbols/electric.svg';
import EyeIcon from '~/../symbols/eye.svg';
import HeartIcon from '~/../symbols/heart.svg';
import PercentageIcon from '~/../symbols/percentage.svg';
import ShieldIcon from '~/../symbols/shield.svg';
import CarIcon from '~/../symbols/car.svg';
import PlugIcon from '~/../symbols/plug.svg';
import UsageIcon from '~/../symbols/usage.svg';
import ReceiptIcon from '~/../symbols/receipt.svg';
import QuestionIcon from '~/../symbols/question.svg';
import TooltipIcon from '~/../symbols/tooltip.svg';
import TimerIcon from '~/../symbols/timer.svg';

/* Utilities */
import { getCloudimageUrl } from '~/utilities';

export default function ProductSticker({ sticker, stickerTooltips = {}, ...props }) {
    const [open, setOpen] = useState(false);

    if (!sticker || !sticker.name || !sticker.theme) return null;

    const tooltip = stickerTooltips?.[sticker?.tooltip_id] || null;
    const icons = {
        label: LabelIcon.url,
        star: StarIcon.url,
        electric: ElectricIcon.url,
        eye: EyeIcon.url,
        heart: HeartIcon.url,
        percentage: PercentageIcon.url,
        shield: ShieldIcon.url,
        car: CarIcon.url,
        plug: PlugIcon.url,
        usage: UsageIcon.url,
        receipt: ReceiptIcon.url,
        question: QuestionIcon.url,
        tooltip: TooltipIcon.url,
        timer: TimerIcon.url
    }

    return (
        <>
            <div className={`card__labels-label label--${sticker.theme} label--sticker d-flex align-items-center ${tooltip ? 'cursor-pointer' : ''}`} onClick={(e) => { if (tooltip) { e.preventDefault(); setOpen(true); } }}>
                <Icon size={16} url={icons[sticker.icon]} type={sticker.icon} />
                <span className="label__text">{sticker.name}</span>
                {tooltip ? (
                    <Icon className="text-muted--60" size={16} url={TooltipIcon} />
                ) : null}
            </div>
            {tooltip ? (
                <Modal
                    className="modal--sticker"
                    open={open}
                    handleClose={() => setOpen(false)}
                    modalTitle={sticker.name}
                    modalBody={(
                        <div className="row gutters-0">
                            {tooltip.image ? (
                                <div className="col-12">
                                    <Image
                                        className="img-fluid"
                                        src={getCloudimageUrl(tooltip.image, { w: 600, h: 341, func: 'crop' })}
                                        srcSet={`${getCloudimageUrl(tooltip.image, { w: 1200, h: 682, func: 'crop' })} 2x`}
                                        alt={sticker.name}
                                        width={960}
                                        height={540}
                                        sources={[
                                            {
                                                set: {
                                                    '1x': getCloudimageUrl(tooltip.image, { w: 560, h: 318, func: 'crop' }),
                                                    '2x': getCloudimageUrl(tooltip.image, { w: 1120, h: 636, func: 'crop' }),
                                                },
                                                media: '(min-width: 992px)',
                                            },
                                            {
                                                set: {
                                                    '1x': getCloudimageUrl(tooltip.image, { w: 992, h: 545, func: 'crop' }),
                                                    '2x': getCloudimageUrl(tooltip.image, { w: 1884, h: 1090, func: 'crop' }),
                                                },
                                                media: '(min-width: 768px)',
                                            },
                                            {
                                                set: {
                                                    '1x': getCloudimageUrl(tooltip.image, { w: 768, h: 436, func: 'crop' }),
                                                    '2x': getCloudimageUrl(tooltip.image, { w: 1536, h: 872, func: 'crop' }),
                                                },
                                                media: '(min-width: 600px)',
                                            },
                                        ]}
                                    />
                                </div>
                            ) : null}
                            <div className="col-12">
                                <div className="sticker-content">
                                    <div className={`card__labels-label label--${sticker.theme} label--sticker d-flex align-items-center mb-4`}>
                                        <Icon size={16} url={icons[sticker.icon]} type={sticker.icon} />
                                        <span className="label__text">{sticker.name}</span>
                                    </div>
                                    <div dangerouslySetInnerHTML={{ __html: tooltip.text }} ></div>
                                </div>
                            </div>
                        </div>
                    )}
                />
            ) : null}
        </>
    );
}
